module.exports = __webpack_public_path__ + "static/img/JED-WALTER.db67c55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/JED-WALTER.jpg
// module id = Ug+G
// module chunks = 0